import { Capacitor } from '@capacitor/core'
import { useAxios } from '@healthblocks-io/core'
import { useCallback } from 'react'

export function useMarkMessageAsRead() {
  const axios = useAxios()

  // Mark specific message as read when user interacts with notification
  return useCallback(
    async (messageId: string) => {
      if (!Capacitor.isNativePlatform()) {
        return
      }

      try {
        await axios.post(`/messages/${messageId}/mark-read`)
      } catch (error) {
        console.error('Error marking message as read:', error)
      }
    },
    [axios],
  )
}
